<template>
  <div class="note-item row" @click.prevent="handleClick">
    <div class="note-height col-xl-8 col-lg-7">
      <div class="note-info">
        <div class="note-text" title="">
          <div class="note-line">
            <span class="date">{{ postAt }}</span>
            <div v-if="note.author" class="note-classmata">
              作者：{{ note.author }}
            </div>
          </div>
          <h4 class="note-title">
            <a :href="`article/${note.slug}`" title="">
              {{ note.title }}
            </a>
          </h4>
          <input type="hidden"
                 class="type_id_specId_key"
                 :data-type_id_specId_key="typeIdSpecIdKey"
                 name="type_id_specId_key[]"
                 :value="typeIdSpecIdKey">
          <p
            v-if="note.description"
            class="note-depiction"
            v-html="note.description.replace(/\r?\n/g, '<br />')"
          ></p>
          <a
            :href="`article/${note.slug}`"
            class="note-button"
            title=""
            >更多資訊</a
          >
        </div>
        <div class="note-bottom">
          <a
            v-if="note.textClassMetas && note.classMetaId"
            :href="`article?classMetaId=${note.classMetaId}`"
            class="note-tag badge badge-primary"
            title=""
          >
            {{ note.textClassMetas }}
          </a>
          <button
            type="button"
            :class="favoriteButtonClass"
            @click="changeFavorite"
          >
            <div class="collet-icon">
              <img src="img/pic/love.svg" alt="icon"/>
            </div>
            加入收藏
          </button>
        </div>
      </div>
    </div>
    <div class="note-pic col-xl-4 col-lg-5">
      <a :href="`article/${note.slug}`" title="">
        <img :src="note.picUrl" @error="handleImageError" title="" alt="" />
      </a>
      <!-- <img src="img/pic/note-test.jpg" title="" alt="" /> -->
    </div>
  </div>
</template>

<script>
import Datalayer from 'Controllers/Web/Datalayer';

export default {
  props: {
    note: {},
    postAt: {
      type: String,
      default: '',
    },
    favoriteAdded: {
      type: Boolean,
      defalut: false,
    },
    noteId: {
      type: Number,
      default: 0,
    },
    pageName: {
      type: String,
      default: '',
    },
    pagePosition: {
      type: String,
      default: '',
    },
    typeIdSpecIdKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      favoriteAddedData: false,
      link: '',
    };
  },
  computed: {
    favoriteButtonClass() {
      return {
        favoriteBtn: true,
        'note-collet btn btn-lg': true,
        added: this.favoriteAddedData,
      };
    },
  },
  created() {
    this.favoriteAddedData = this.favoriteAdded;
    this.link = `article/${this.note.slug}`;
  },
  mounted() {},
  methods: {
    async handleClick(event) {
      if(this.pagePosition !== '' || this.pageName !== ''){
        event.preventDefault();
        const position = `${this.pageName}_article_${this.pagePosition}`;
        await Datalayer.storeDatalayerEvent(this.note.title, position);
      }
      window.location.href = this.link;
    },
    async changeFavorite() {
      // 改為相反的狀態
      this.favoriteAddedData = !this.favoriteAddedData;

      let response;
      try {
        response = await axios.post(
          `article/favorite/${this.noteId}`,
        );
      } catch (error) {
        console.warn(error);
      }

      const { data } = response;

      if (data.status === 'not login') {
        window.location.href = 'user/login';

        global.Message.show('請先登入會員');

        return false;
      }

      if (data.favoriteAdded) {
        global.Message.show('已經加入喜愛文章');
      } else {
        global.Message.show('已經從喜愛文章中移除');
      }

      this.favoriteAddedData = data.favoriteAdded;
    },
    handleImageError(event) {
      event.target.src = 'img/pic/no_image_icon.png';
    }
  },
};
</script>
